import React from 'react'
import { modals } from '@mantine/modals'
import { Image, Box, Text } from '@mantine/core'
import { notificationSuccess, notificationError } from '../Notifications'
import SearchMascot from '../../../assets/img/mascot/18.png'


export const deleteRecentDocumentSourcingRequest = ( title, id, payload, name, functionDelete, closeModal, reloadData ) => {

  const handleDeleteData = async (id, payload) => {
    try {
      const response = await functionDelete(id, payload)
      if (response.success) {
        notificationSuccess(`Delete ${title} successfully`,  `Data ${title} successfully deleted`)
        reloadData()
        closeModal()
        modals.closeAll()
      }
    } catch (error) {
      console.log(error)
      notificationError(`Delete ${title} error`, `Cannot delete data ${title} `)
    }
  }

  return modals.openConfirmModal({
    centered: 'true',
    closeOnConfirm: false,
    withCloseButton: false,
    size: 'lg',
    children: (
      <Box>
        <Box ta='center'>
          <Image src={SearchMascot} fit='contain' h='180' my={20} />
          <Text fw={500} mb={4}>Are you sure you want to delete document? </Text>
          <Text fw='bold' mb={14}>"{name}"</Text>
          <Text fz='sm' c='gray.6' mb={20}>Data will be permanently removed. This action cannot be undone.</Text>
        </Box>
      </Box>
    ),
    labels: { confirm: 'Delete Now', cancel: "Cancel" },
    confirmProps: { color: 'red' },
    onConfirm: () => handleDeleteData(id, payload),
  })
}
